import { CKSwitch } from '@clearkit/react';

export default function ConfigurationBooleanToggleSection({
  title,
  description,
  checked,
  onChange = () => {},
  ...props
}) {
  if (!props.id) {
    // eslint-disable-next-line no-console
    console.error(
      `You did not include an 'id' property for the Boolean Toggle Section called ${title}. This will probably not work`,
    );
  }
  return (
    <div className="flex flex-row py-6 pl-6 pr-8 gap-6">
      <div className="flex-grow">
        <h3 className="mb-2 text-base font-medium text-gray-600">{title}</h3>

        <div className="text-base text-gray-500">{description}</div>
      </div>

      <div className="flex-shrink-0 w-24">
        <CKSwitch
          checked={checked}
          srOnly={false}
          onChange={(event) => {
            onChange(event.target.checked);
          }}
          {...props}>
          {checked ? 'Enabled' : 'Disabled'}
        </CKSwitch>
      </div>
    </div>
  );
}
